let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lmiNT")).then(() => parcelRequire('i3y1k'));